import { render, staticRenderFns } from "./OsToolbar.vue?vue&type=template&id=6fd89d0f&scoped=true"
import script from "./OsToolbar.vue?vue&type=script&lang=ts"
export * from "./OsToolbar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd89d0f",
  null
  
)

export default component.exports